module.exports = __webpack_public_path__ + "static/media/insurance_icon.d44e588d.svg";